import { lazy } from "react"
export default[
    {
        path:"/register-docs",
        component: lazy(()=>import("../../views/regisdoc/"))
    }
]